// extracted by mini-css-extract-plugin
export default {"header":"roles_gantt_view-module___header___d9e8842c"};